/** Common reagent names for autocomplete search */
export const COMMON_REAGENTS: { name: string; formula?: string; cas?: string }[] = [
  { name: "Acetic acid", formula: "CH₃COOH", cas: "64-19-7" },
  { name: "Acetic anhydride", formula: "C₄H₆O₃", cas: "108-24-7" },
  { name: "Acetone", formula: "C₃H₆O", cas: "67-64-1" },
  { name: "Acetonitrile", formula: "CH₃CN", cas: "75-05-8" },
  { name: "Aluminium chloride", formula: "AlCl₃", cas: "7446-70-0" },
  { name: "Ammonia", formula: "NH₃", cas: "7664-41-7" },
  { name: "Ammonium chloride", formula: "NH₄Cl", cas: "12125-02-9" },
  { name: "Boron trifluoride etherate", formula: "BF₃·Et₂O", cas: "109-63-7" },
  { name: "n-Butyllithium", formula: "C₄H₉Li", cas: "109-72-8" },
  { name: "Calcium hydride", formula: "CaH₂", cas: "7789-78-8" },
  { name: "Celite", formula: "SiO₂", cas: "68855-54-9" },
  { name: "Cesium carbonate", formula: "Cs₂CO₃", cas: "534-17-8" },
  { name: "Chloroform", formula: "CHCl₃", cas: "67-66-3" },
  { name: "Copper(I) iodide", formula: "CuI", cas: "7681-65-4" },
  { name: "DIAD", formula: "C₈H₁₄N₂O₄", cas: "2446-83-5" },
  { name: "DIBAL-H", formula: "C₆H₁₅Al", cas: "1191-15-7" },
  { name: "Dichloromethane", formula: "CH₂Cl₂", cas: "75-09-2" },
  { name: "Diethyl ether", formula: "C₄H₁₀O", cas: "60-29-7" },
  { name: "Diisopropylethylamine", formula: "C₈H₁₉N", cas: "7087-68-5" },
  { name: "DMAP", formula: "C₇H₁₀N₂", cas: "1122-58-3" },
  { name: "DMF", formula: "C₃H₇NO", cas: "68-12-2" },
  { name: "DMSO", formula: "C₂H₆OS", cas: "67-68-5" },
  { name: "EDC·HCl", formula: "C₈H₁₇N₃·HCl", cas: "25952-53-8" },
  { name: "Ethanol", formula: "C₂H₅OH", cas: "64-17-5" },
  { name: "Ethyl acetate", formula: "C₄H₈O₂", cas: "141-78-6" },
  { name: "Grubbs 2nd gen catalyst", formula: "C₄₆H₆₅Cl₂N₂PRu", cas: "246047-72-3" },
  { name: "HATU", formula: "C₁₀H₁₅N₆O₂PF₆", cas: "148893-10-1" },
  { name: "Hexanes", formula: "C₆H₁₄", cas: "110-54-3" },
  { name: "HOBt", formula: "C₆H₅N₃O", cas: "2592-95-2" },
  { name: "Hydrochloric acid", formula: "HCl", cas: "7647-01-0" },
  { name: "Hydrogen peroxide", formula: "H₂O₂", cas: "7722-84-1" },
  { name: "Imidazole", formula: "C₃H₄N₂", cas: "288-32-4" },
  { name: "Lithium aluminium hydride", formula: "LiAlH₄", cas: "16853-85-3" },
  { name: "Lithium hydroxide", formula: "LiOH", cas: "1310-65-2" },
  { name: "Magnesium sulfate", formula: "MgSO₄", cas: "7487-88-9" },
  { name: "mCPBA", formula: "C₇H₅ClO₃", cas: "937-14-4" },
  { name: "Methanol", formula: "CH₃OH", cas: "67-56-1" },
  { name: "N-Bromosuccinimide", formula: "C₄H₄BrNO₂", cas: "128-08-5" },
  { name: "Oxalyl chloride", formula: "C₂O₂Cl₂", cas: "79-37-8" },
  { name: "Palladium on carbon", formula: "Pd/C", cas: "7440-05-3" },
  { name: "Pd(PPh₃)₄", formula: "C₇₂H₆₀P₄Pd", cas: "14221-01-3" },
  { name: "Pd₂(dba)₃", formula: "C₅₁H₄₂O₃Pd₂", cas: "51364-51-3" },
  { name: "Potassium carbonate", formula: "K₂CO₃", cas: "584-08-7" },
  { name: "Potassium tert-butoxide", formula: "C₄H₉KO", cas: "865-47-4" },
  { name: "Pyridine", formula: "C₅H₅N", cas: "110-86-1" },
  { name: "Silica gel", formula: "SiO₂", cas: "112926-00-8" },
  { name: "Sodium bicarbonate", formula: "NaHCO₃", cas: "144-55-8" },
  { name: "Sodium borohydride", formula: "NaBH₄", cas: "16940-66-2" },
  { name: "Sodium hydride", formula: "NaH", cas: "7646-69-7" },
  { name: "Sodium hydroxide", formula: "NaOH", cas: "1310-73-2" },
  { name: "Sodium sulfate", formula: "Na₂SO₄", cas: "7757-82-6" },
  { name: "Sulfuric acid", formula: "H₂SO₄", cas: "7664-93-9" },
  { name: "TBAF", formula: "C₁₆H₃₆FN", cas: "429-41-4" },
  { name: "TEA (Triethylamine)", formula: "C₆H₁₅N", cas: "121-44-8" },
  { name: "THF", formula: "C₄H₈O", cas: "109-99-9" },
  { name: "Thionyl chloride", formula: "SOCl₂", cas: "7719-09-7" },
  { name: "Titanium isopropoxide", formula: "Ti(OiPr)₄", cas: "546-68-9" },
  { name: "Toluene", formula: "C₇H₈", cas: "108-88-3" },
  { name: "Triphenylphosphine", formula: "C₁₈H₁₅P", cas: "603-35-0" },
  { name: "Water", formula: "H₂O", cas: "7732-18-5" },
  { name: "Zinc chloride", formula: "ZnCl₂", cas: "7646-85-7" },
];
